import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  Radio,
  RadioGroup,
  TextField,
} from "@mui/material";
import { MenuManagementContext } from "pages/system-management/menu-management";
import { useContext, useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";

export default function RegistForm() {
  const {
    register,
    handleSubmit,
    control,
    setValue,
    setError,
    clearErrors,
    getValues,
    watch,
    formState,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  });
  const [openSubmitConfirm, setOpenSubmitConfirm] = useState(false);
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [submitData, setSubmitData] = useState("");

  const {
    submitHandler,
    selectMenu,
    mode,
    handleDelete,
    d1Menu,
    d2Menu,
    d3Menu,
  } = useContext(MenuManagementContext);

  useEffect(() => {
    clearErrors(["cd", "nm", "url"]);

    if (selectMenu && mode == "modify") {
      setValue(
        "cd",
        selectMenu.cd.slice(selectMenu.cd.length - 2, selectMenu.cd.length)
      );
      setValue("nm", selectMenu.nm);
      setValue("url", selectMenu.url);
      setValue("useYn", selectMenu.useYn);
    } else {
      setValue("cd", "");
      setValue("nm", "");
      setValue("url", "");
      setValue("useYn", "");
    }
  }, [selectMenu, mode]);

  const duplicationCheck = () => {
    console.log("selectMenu: ", selectMenu);
    console.log("d1Menu: ", d1Menu);
    console.log("d2Menu: ", d2Menu);
    console.log("d3Menu: ", d3Menu);
    if (selectMenu) {
      let menu = "";
      switch (selectMenu.cd.length) {
        case 2:
          menu = _.find(d1Menu, (item) => {
            return item.cd == getValues("cd");
          });
          break;
        case 4:
          menu = _.find(d2Menu, (item) => {
            console.log("item.cd: ", item.cd);
            console.log(
              '`${item.parentCd}${getValues("cd")}`: ',
              `${item.parentCd}${getValues("cd")}`
            );
            return item.cd == `${item.parentCd}${getValues("cd")}`;
          });
          break;
        case 6:
          menu = _.find(d3Menu, (item) => {
            return item.cd == getValues("cd");
          });
          break;
      }

      console.log("menu: ", menu);
      if (menu) {
        setError("cd", {
          type: "duplicate",
        });
      } else {
        clearErrors(["cd.duplicate"]);
      }
    }
  };

  const onSubmit = (data) => {
    console.log("selectMenu: ", selectMenu);

    if (mode != "modify") duplicationCheck();

    if (selectMenu) {
      if (mode == "modify") {
        data.depth = selectMenu.depth;
        data.parentCd = selectMenu.parentCd;
      } else {
        data.depth = Number(selectMenu.depth) + 1;
        data.parentCd = selectMenu.cd;
      }

      data.cd = data.parentCd + data.cd;
      // data.useYn = "Y";
    } else {
      data.depth = 1;
    }

    setSubmitData(data);

    setOpenSubmitConfirm(true);
  };

  const handleSubmitData = () => {
    submitHandler(submitData);

    setOpenSubmitConfirm(false);
  };

  const onError = (err) => {
    console.log("err: ", err);
  };

  const handleDeleteClick = () => {
    setOpenDeleteConfirm(true);
  };

  const handleDeleteConfirm = () => {
    handleDelete();
    setOpenDeleteConfirm(false);
  };

  return (
    <>
      <h3>▶ 메뉴 정보 (* 필수항목)</h3>
      <form onSubmit={handleSubmit(onSubmit, onError)}>
        <table className="table">
          <tbody>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="codeGroup">
                  메뉴코드
                </InputLabel>
              </th>
              <td scope="row">
                <Grid container spacing={1}>
                  <Grid item xs={10}>
                    <Controller
                      rules={{
                        required: true,
                      }}
                      name="cd"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          id="cd"
                          disabled={mode == "modify"}
                          inputProps={{
                            maxLength: 100,
                            placeholder: "AA",
                          }}
                        />
                      )}
                    />
                    {formState.submitCount > 0 &&
                      errors.cd?.type === "required" && (
                        <FormHelperText>
                          메뉴코드를 입력해주세요.
                        </FormHelperText>
                      )}
                    {errors.cd?.type === "duplicate" && (
                      <FormHelperText>이미 사용중인 코드입니다.</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={2}>
                    {mode != "modify" && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={duplicationCheck}
                      >
                        중복 확인
                      </Button>
                    )}
                  </Grid>
                </Grid>
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="codeGroup">
                  메뉴명
                </InputLabel>
              </th>
              <td scope="row">
                <Controller
                  rules={{
                    required: true,
                  }}
                  name="nm"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      id="nm"
                      inputProps={{
                        maxLength: 100,
                        placeholder: "텍스트를 입력해주세요.",
                      }}
                    />
                  )}
                />
                {formState.submitCount > 0 &&
                  errors.nm?.type === "required" && (
                    <FormHelperText>메뉴명을 입력해주세요.</FormHelperText>
                  )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel required htmlFor="codeGroup">
                  URL
                </InputLabel>
              </th>
              <td scope="row">
                <Controller
                  rules={{
                    required: true,
                  }}
                  name="url"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      fullWidth
                      id="url"
                      inputProps={{
                        maxLength: 100,
                        placeholder: "URL을 입력해주세요.",
                      }}
                    />
                  )}
                />
                {formState.submitCount > 0 &&
                  errors.url?.type === "required" && (
                    <FormHelperText>URL을 입력해주세요.</FormHelperText>
                  )}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <InputLabel htmlFor="codeGroup">사용여부</InputLabel>
              </th>
              <td scope="row">
                <Controller
                  defaultValue=""
                  name="useYn"
                  control={control}
                  render={({ field: { onChange, value } }) => (
                    <RadioGroup
                      aria-label="disp"
                      name="useYn"
                      row
                      value={value}
                      onChange={onChange}
                    >
                      <FormControlLabel
                        value="Y"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="사용"
                      />
                      <FormControlLabel
                        value="N"
                        control={
                          <Radio
                            size="small"
                            color="primary"
                            icon={<span className="radio-icon" />}
                            checkedIcon={
                              <span className="radio-icon-checked" />
                            }
                          />
                        }
                        label="미사용"
                      />
                    </RadioGroup>
                  )}
                />
              </td>
            </tr>
          </tbody>
        </table>

        <Grid container spacing={3} className="mt-1">
          <Grid item xs={6}>
            <Box mt={1}>
              <Button
                variant="contained"
                size="small"
                color="primary"
                onClick={(e) => {
                  handleDeleteClick();
                }}
              >
                삭제
              </Button>
            </Box>
          </Grid>
          <Grid item xs={6}>
            <Box mt={1} display="flex" justifyContent="flex-end">
              <Box display="flex" justifyContent="flex-end">
                <Button variant="contained" color="secondary" type="Button">
                  취소
                </Button>
                <Button variant="contained" color="primary" type="Submit">
                  {mode == "modify" ? <>수정</> : <>등록</>}
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </form>

      <Dialog
        open={openSubmitConfirm}
        onClose={() => {
          setOpenSubmitConfirm(false);
        }}
        className="alert-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {mode == "modify" ? <>수정하시겠습니까?</> : <>등록하시겠습니까?</>}
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setOpenSubmitConfirm(false);
            }}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmitData}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteConfirm}
        onClose={() => {
          setOpenDeleteConfirm(false);
        }}
        className="alert-dialog"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">삭제하시겠습니까?</DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setOpenDeleteConfirm(false);
            }}
            color="secondary"
          >
            취소
          </Button>
          <Button
            variant="contained"
            onClick={handleDeleteConfirm}
            color="primary"
            autoFocus
          >
            확인
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
